import L from "leaflet";

/**
 * Punaise minimaliste inspirée du logo UrbSex (forme pin + "U" interne).
 * Couleurs par catégorie :
 * - temporaire : orange/rouge
 * - audacieux  : jaune
 * - facile     : vert
 *
 * Optionnel (pour plus tard) :
 * - hidden: true => opacité 50%
 */
export const createMarkerIcon = (category, opts = {}) => {
  const { hidden = false } = opts;

  // Couleurs demandées
  let color = "#34C759"; // facile = vert
  if (category === "audacieux") color = "#FFD60A"; // jaune
  if (category === "temporaire") color = "#FF3B30"; // orange/rouge

  const opacity = hidden ? 0.5 : 1;

  // Taille du marker (SVG). Ajustable si besoin.
  const w = 34;
  const h = 44;

  const svg = `
    <svg width="${w}" height="${h}" viewBox="0 0 64 80" xmlns="http://www.w3.org/2000/svg" style="display:block;">
      <!-- Ombre légère -->
      <g style="filter: drop-shadow(0px 2px 2px rgba(0,0,0,0.35)); opacity:${opacity};">
        <!-- Pin -->
        <path d="M32 2
                 C20 2 10 12 10 24
                 C10 42 32 78 32 78
                 C32 78 54 42 54 24
                 C54 12 44 2 32 2 Z"
              fill="${color}"/>
        <!-- 'U' interne (stroke) -->
        <path d="M24 18
                 V34
                 C24 42 40 42 40 34
                 V18"
              fill="none"
              stroke="rgba(0,0,0,0.85)"
              stroke-width="8"
              stroke-linecap="round"
              stroke-linejoin="round"/>
      </g>
    </svg>
  `;

  return L.divIcon({
    className: "urbsex-pin-icon",
    html: svg,
    iconSize: [w, h],
    iconAnchor: [w / 2, h],     // pointe en bas-centre
    popupAnchor: [0, -h + 8],   // si un jour tu ajoutes des popups
  });
};